import styled from '@emotion/styled'

import { Text } from 'theme-ui'

import { WithTheme } from './../../../setup'
import media from './../../../common/MediaQueries'

export const PlatformBoxStyled = styled.div`
  display: flex;
  width: 100%;
  @media ${media.phone} {
    flex-direction: column;
  }
`

export const PlatformBoxTitleStyled = styled(Text)`
  text-transform: uppercase;
  width: 50%;
  @media ${media.phone} {
    width: 100%;
    text-align: center;
  }
`

export const PlatformBoxContentStyled = styled.div`
  margin-left: 2rem;
  width: 50%;
  @media ${media.phone} {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 0.25rem;
    margin-left: 0;
  }
`

export const PlatformBoxButtonsStyled = styled.div`
  @media ${media.maxPhone} {
    > div,
    > div a {
      width: 100%;
    }
  }

  &:not(:first-of-type) {
    margin-top: 1.125rem;
  }
`
